import { gql } from "@apollo/client"
import { DestroyPaymentMethodInput, DestroyPaymentMethodPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const PAYMENTS_COMPANY_DESTROY_PAYMENT_METHOD = gql`
  mutation PaymentCompanyDestroyPaymentMethod($paymentMethodId: ID!) {
    destroyPaymentMethod(input: { paymentMethodId: $paymentMethodId }) {
      errors
    }
  }
`

export type DestroyPaymentMethodsOptions = InjectedOptions<
  { destroyPaymentMethod: DestroyPaymentMethodPayload },
  DestroyPaymentMethodInput
>
/**
 * you may need to revoke authorization for payment method before destroying
 * @see useDeletePaymentMethod
 */
export const useDestroyPaymentMethod = (options?: DestroyPaymentMethodsOptions) =>
  useMutation(PAYMENTS_COMPANY_DESTROY_PAYMENT_METHOD, {
    analyticsEventName: "payment_method_deleted",
    ...options,
  })
